import { DayjsDatePicker } from '../DayjsDatePicker'

export const DatePicker = (props: any) => {
  const { label } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: 200, justifyItems: 'flex-end' }}>
        {label && <span>{label}:</span>}
      </div>
      <div style={{ width: '100%' }}>
        <DayjsDatePicker {...props} />
      </div>
    </div>
  )
}

DatePicker.defaultProps = {
  style: {
    width: '100%',
    marginBottom: 20
  }
}
